module.exports = __webpack_public_path__ + "img/icon_map_8_on_100.e16da8e7.png";